import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=3e30f34f&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e30f34f')) {
      api.createRecord('3e30f34f', component.options)
    } else {
      api.reload('3e30f34f', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=3e30f34f&", function () {
      api.rerender('3e30f34f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetofferdetail/components/Faq.vue"
export default component.exports